const LookupTypes = {
    floorBySiteId: 'building.site.id',
    company: 'company',
    department: 'department',
    site: 'site',
    area: 'area',
    accessTimePattern: 'accessTimePattern',
    days: 'days',
    zone: 'zone',
    timeZone: 'timeZone',
    timePattern: 'timePattern',
    reader: 'reader',
    controllerName: 'terminal.controller.deviceImprox.id',
    zoneName: 'zoneByZoneId.id',
    zoneController: 'zoneByZoneId.controller.deviceImprox.id',
    zoneSite: 'zoneByZoneId.controller.deviceImprox.site.id',
    buildingSite: 'building.site',
    tourRouteSite: 'area.site.id',
    eventActionTypes: 'setting.settingType.id',
    reportType: 'reportType.id',
    holidayReportSite: 'site.id',
    door: 'locName',
    deviceType: 'hdtName',
    zoneReport: 'location.zoneByZoneId.id',
    locationAreaReport: 'location.id',
    departmentReport: 'deptName',
    companyReport: 'compName',
    tagCodeType: 'ttNameOriginal',
    terminal: 'terminal',
    controller: 'controller',
    building: 'building',
    location: 'location',
    eventType: 'eventType',
    type: 'type',
    zoneBySiteId:'controller.deviceImprox.site.id',
    profileId: "profileId",
    profile_id: "profile.id",
    MusteringStatuses: "status",
    groupType: "agType",
    auditType: "auditType",
    auditSubType: "auditSubType",
    auditActionType: "auditActionType",
    auditOperator: "auditSession",
    masterByTrMasterId: "masterByTrMasterId",
    ossDevice: 'ossDevice',
    ksKeyTypeName: 'ksKeyType',
    auditTypeId: "auditTypeId",
    auditSubTypeId: "auditSubTypeId",
    auditActionTypeId: "auditActionTypeId",
    masterId: "masterId",
    companyId: "companyId",
    departmentId: "departmentId"
};

export default LookupTypes;
